import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.UserSignIn.components.ConfirmSignUp.title',
    defaultMessage: 'Confirm signup',
  },
  password: {
    id: 'containers.UserSignIn.components.ConfirmSignUp.password',
    defaultMessage: 'Password',
  },
  repeatPassword: {
    id: 'containers.UserSignIn.components.ConfirmSignUp.repeatPassword',
    defaultMessage: 'Repeat password',
  },
  loading: {
    id: 'containers.UserSignIn.components.ConfirmSignUp.loading',
    defaultMessage: 'Loading..',
  },
  finish: {
    id: 'containers.UserSignIn.components.ConfirmSignUp.finish',
    defaultMessage: 'Finish',
  },
  needHelp: {
    id: 'containers.UserSignIn.components.ConfirmSignUp.needHelp',
    defaultMessage: 'Need help with anything?',
  },
  reachOut: {
    id: 'containers.UserSignIn.components.ConfirmSignUp.reachOut',
    defaultMessage: 'Reach out to us',
  },
})
